import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { ApiUtils } from '@shared/utils';
import { MiscApi } from '@shared/api/rest';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getAvailableCurrenciesEffect = createEffect((params: IQueryParams) => MiscApi.getAvailableCurrencies(params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(getAvailableCurrenciesEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAvailableCurrenciesEffect.pending, (_, data) => data)
  .on(getAvailableCurrenciesEffect.fail, () => false)
  .on(getAvailableCurrenciesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAvailableCurrenciesEffect, () => null)
  .on(getAvailableCurrenciesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAvailableCurrenciesEffect.done, () => null)
  .reset(clearEvent);

export const $initialCurrenciesAvailableStore = {
  events: {
    getAvailableCurrencies: ApiUtils.wrapperApi(getAvailableCurrenciesEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
